import { render } from "./EmailModal.vue?vue&type=template&id=4312a5b6&ts=true"
import script from "./EmailModal.vue?vue&type=script&lang=ts"
export * from "./EmailModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__